import { mean } from 'mathjs';

import appConstants from "../appConstants";

export function convertTimestampToDate(timestamp)
{
	var timestampTemp = new Date(timestamp);
	var dateType = timestampTemp.toDateString();
	return dateType;
}

export function convertTimestampToDateTime(timestamp)
{
	var timestampTemp = new Date(timestamp);
	var dateType = timestampTemp.toDateString();
	dateType += " " + convertTimestampToTime(timestamp);
	return dateType;
}

export function convertTimestampToTime(timestamp)
{
	var timestampTemp = new Date(timestamp);
	var hours = timestampTemp.getHours();
	var ampm = hours >= 12 ? 'pm' : 'am';
	hours = hours > 12 ? hours - 12 : hours;
	var hoursLabel = (hours < 10) ? '0' + hours : hours;
	var minute = timestampTemp.getMinutes();
	var minuteLabel = (minute < 10) ? '0' + minute : minute;
	return hoursLabel + ":" + minuteLabel + " " + ampm;
}

export function convertSecondsToTime(seconds)
{
	var seconds = Number(seconds);
	var h = Math.floor(seconds / 3600);
	var m = Math.floor(seconds % 3600 / 60);
	var s = Math.floor(seconds % 3600 % 60);
	var hDisplay = h > 0 ? h > 9 ? h + ":" : "0" + h + ":" : "00:";
	var mDisplay = m > 0 ? m > 9 ? m + ":" : "0" + m + ":" : "00:";
	var sDisplay = s > 0 ? s > 9 ? s : "0" + s : "00";
	return hDisplay + mDisplay + sDisplay;
}

export function convertTimeStampToRequiredFormat(timestamp, format)
{
	var returnDate = "";

	var timestampInMilliSeconds = ((timestamp/1000).toFixed(0)) * 1000;
	var dateObj = new Date(timestampInMilliSeconds);
	var year = dateObj.getFullYear();
	var month = ("0" + (dateObj.getMonth() + 1)).slice(-2);
	var date = ("0" + dateObj.getDate()).slice(-2);
	var hours = ("0" + dateObj.getHours()).slice(-2);
	var minutes = ("0" + dateObj.getMinutes()).slice(-2);
	var seconds = ("0" + dateObj.getSeconds()).slice(-2);
	if(format == "MM/DD/YYYY HH:MM:SS")
	{
		returnDate = month + "/" + date + "/" + year + " " + hours + ":" + minutes + ":" + seconds;
	} else if(format == "MM-dd-YYYY HH:MM:SS")
	{
		returnDate = month + "-" + date + "-" + year + " " + hours + ":" + minutes + ":" + seconds;
	} else if(format == "MM-dd-YYYY HH:MM")
	{
		returnDate = month + "-" + date + "-" + year + " " + hours + ":" + minutes;
	}
	return returnDate;
}

export function convertUTCDateToLocalDate(timestamp)
{
	var date = new Date(timestamp)
	var utcTimeStamp = (new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(),  date.getHours(), date.getMinutes(), date.getSeconds()))).getTime();
	return convertTimestampToDateTime(utcTimeStamp)
}

export function convertUTCDateToLocalDateTimeStamp(timestamp) 
{
	var date = new Date(timestamp)
	return (new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(),  date.getHours(), date.getMinutes(), date.getSeconds()))).getTime();
}

export function getIdxByField(list, data, field)
{
	var existingIdx = -1;
	try	
	{
		existingIdx = list.findIndex(obj => obj[field] == data[field]);
	} catch (error)
	{
		console.log(error)
	}
	return existingIdx;
}

export function givenValueNotNull(list, field)
{
	var givenValueNotNullFlg = false;
	try	
	{
		var existingIdx = list.findIndex(obj => obj[field] != null);
		if(existingIdx > -1)
		{
			givenValueNotNullFlg = true;
		}
	} catch (error)
	{
		console.log(error)
	}
	return givenValueNotNullFlg;
}

export function getIdx(list, data)
{
	var existingIdx = -1;
	try	
	{
		existingIdx = list.findIndex(val => val == data);
	} catch (error)
	{
		console.log(error)
	}
	return existingIdx;
}

export function sortByText(currText, nextText)
{
	var rtnVal = 0;
	if (currText < nextText)
	{
		rtnVal = -1;
	} else if (currText > nextText)
	{
		rtnVal = 1;
	}
	return rtnVal;
}

export function sortByDateTime(currTimestamp, nextTimestamp)
{
	return (nextTimestamp - currTimestamp);
}

// Session
export function getSessionStorageData(key)
{
	var sessionDataByKey = JSON.parse(sessionStorage.getItem(key));
	return sessionDataByKey;
}

export function removeSessionStorageData(key)
{
	sessionStorage.removeItem(key);
}

export function saveSessionStorageData(key, val)
{
	sessionStorage.setItem(key, JSON.stringify(val));
}

// Dynamic API URL functions
export function buildDynamicApiBaseUrl(customerDomain, apiBaseUrl)
{
	if (!customerDomain || !apiBaseUrl)
	{
		return apiBaseUrl;
	}

	try
	{
		const url = new URL(apiBaseUrl);
		const hostParts = url.hostname.split('.');
		hostParts[0] = customerDomain + appConstants.DYNAMIC_API_BASE_URL_DELIMETER + hostParts[0];
		url.hostname = hostParts.join('.');
		
		return url.toString();
	}
	catch (error)
	{
		console.error('Error building dynamic API URL:', error);
		return apiBaseUrl;
	}
}

export function getApiBaseUrl()
{
	const isDynamicApiUrlEnabled = window.appConfig && window.appConfig.ENABLE_DYNAMIC_API_URL;
	if (!isDynamicApiUrlEnabled)
	{
		return window.appConfig ? window.appConfig.SERVER_URL : '';
	}

	const dynamicApiBaseUrl = getSessionStorageData(appConstants.DYNAMIC_API_BASE_URL_SESSION_STORAGE_KEY);
	
	if (dynamicApiBaseUrl)
	{
		return dynamicApiBaseUrl;
	}
	
	return window.appConfig ? window.appConfig.SERVER_URL : '';
}

export function clearDynamicApiBaseUrl()
{
	removeSessionStorageData(appConstants.DYNAMIC_API_BASE_URL_SESSION_STORAGE_KEY);
}

export function isObjEmpty(obj)
{
	var isObjEmptyFlag = false
	if(obj)
	{
		isObjEmptyFlag = Object.keys(obj).length == 0 ? true : false;
	}
	return isObjEmptyFlag;
}

export function checkIsObject(val)
{
	return typeof val == "object"
}

export function checkIfArray(val)
{
	var isArr = false;
	if(val)
	{
		isArr = Array.isArray(val);
	}
	return isArr;
}

export function checkEmailValid(emailId)
{
	var emailValid = false;
	emailValid = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(emailId);
	return emailValid;
}

export function changeURLWithoutReload(newURL, params)
{
	window.history.pushState(params, "", newURL); // 1 - nextState, 2 - nextTitle
}

export function scrollToView(pageId, scrollBlock)
{
	try
	{
		var element = document.getElementById(pageId);
		if (element)
		{
			element.scrollIntoView({ block: (scrollBlock ? scrollBlock : 'nearest'), behavior: 'auto' })
		}
	} catch (error)
	{
		console.log(error)
	}
}

export function checkValIsNaN(val)
{
	return isNaN(val);
}

export function findDiffInTimeBtwnCurrentTimeAndGivenTime(timestamp)
{
	try 
	{
		var currentTimeStamp = new Date().getTime();
		var diffBtwmTimestamp = currentTimeStamp - timestamp; // This will give difference in milliseconds
		return Math.round(diffBtwmTimestamp / 60000); // 1 minute
	} catch (error)
	{
		console.log("Error ", error)
	}
}

export function highlightSearchTextOnUserName(actualText, searchText, userInactiveStatus)
{
	actualText = (actualText != null && actualText != undefined) ? actualText : "";
	var returnTxt = actualText;
	var searchHeighlightClass = userInactiveStatus ? 'user-inactive-search-highlight' : 'search-highlight';
	if(searchText != "")
	{
		var escapedSearchString = searchText.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
		var regex = new RegExp("(" + escapedSearchString + ")", "gi");
		returnTxt =  actualText.replace(regex, "<mark class="+searchHeighlightClass+">$&</mark>");
	}
	return returnTxt;
}

export function highlightSearchTextOnAssetOrSuperAsset(actualText, searchText)
{
	actualText = (actualText != null && actualText != undefined) ? actualText : "";
	var returnTxt = actualText;
	if(searchText != "")
	{
		// Escape special characters in the search string
		var escapedSearchString = searchText.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
		// Create a regular expression with the escaped search string and the global flag
		var regex = new RegExp("(" + escapedSearchString + ")", "gi");
		// Replace the matched search string with HTML for highlighting
		returnTxt = actualText.replace(regex, "<mark class='search-highlight'>$&</mark>");
	}
	return returnTxt;
}

export function highlightSearchTextOnSensorId(actualText, searchTextObj)
{
	var searchTextArr = [];

	if(searchTextObj.sensorSearchText && searchTextObj.sensorSearchText.length > 0)
	{
		for (var i = 0; i < searchTextObj.sensorSearchText.length; i++)
		{
			if(actualText.toUpperCase().includes(searchTextObj.sensorSearchText[i].toUpperCase()))
			{
				searchTextArr.push(searchTextObj.sensorSearchText[i]);
			}
		}
	}

	if(searchTextArr && searchTextArr.length > 0)
	{
		for (var i = 0; i < searchTextArr.length; i++)
		{
			var escapedSearchString = searchTextArr[i].replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
			var regex = new RegExp("(" + escapedSearchString + ")", "gi");
			actualText = actualText.replace(regex, "<mark class='search-highlight'>$&</mark>");	
		}
	}
	return actualText;
}

export function checkIfUserLastAccessedWithinAllowedDuration(userLastAccessTimeStamp, userInactiveDuration)
{
	var userLastAccessedWithinAllowedDuration = true;
	var currentDate = new Date();
	var userLastAccessDate = new Date(userLastAccessTimeStamp);
	var yearDiffBtwCurrentDateAndUserLastAccessDate = (currentDate.getFullYear() - userLastAccessDate.getFullYear());
	var monthDiffBtwCurrentDateAndUserLastAccessDate = (yearDiffBtwCurrentDateAndUserLastAccessDate * 12) + (currentDate.getMonth() - userLastAccessDate.getMonth());

	var millSecondDiffBtwnCurrentDateAndUserLastAccessDate = (currentDate.getTime() - userLastAccessDate.getTime());
	var secondsDiffBtwCurrentDateAndUserLastAccessDate = Math.floor(millSecondDiffBtwnCurrentDateAndUserLastAccessDate / 1000 );
	var minutesDiffBtwCurrentDateAndUserLastAccessDate = Math.floor(secondsDiffBtwCurrentDateAndUserLastAccessDate/ 60);
	var hoursDiffBtwCurrentDateAndUserLastAccessDate = Math.floor(minutesDiffBtwCurrentDateAndUserLastAccessDate / 60); 
	var daysDiffBtwCurrentDateAndUserLastAccessDate = Math.floor(hoursDiffBtwCurrentDateAndUserLastAccessDate / 24);

	if(((monthDiffBtwCurrentDateAndUserLastAccessDate == userInactiveDuration) && ((secondsDiffBtwCurrentDateAndUserLastAccessDate >= 0) || (minutesDiffBtwCurrentDateAndUserLastAccessDate >= 0) ||
		(yearDiffBtwCurrentDateAndUserLastAccessDate >= 0) || (daysDiffBtwCurrentDateAndUserLastAccessDate >= 0))) || (monthDiffBtwCurrentDateAndUserLastAccessDate > userInactiveDuration))
		{
			userLastAccessedWithinAllowedDuration = false;
		}
	return userLastAccessedWithinAllowedDuration;
}

export function padWithZero(str, size, specialChar)
{
	while (str.length < size)
	{
		str = "0" + str;
	}
	return addSpecialCharInStr(str, specialChar);
}

export function addSpecialCharInStr(str, specialChar)
{
	const strArr = [];
	
	for (let i = 0; i < str.length; i += 2) {
		strArr.push(str.substr(i, 2));
	}
	
	str = strArr.join(specialChar);
	return str;
}

export function isHex(hexString)
{
	var regex = /[0-9A-Fa-f]/g;
	if(hexString.match(regex))
	{
		return true;
	} else
	{
		return false;
	}
}

export function removeHyphenFromText(text)
{
	var hyphenRemovedText = text.replace(/-/g, '');
	return hyphenRemovedText;
}

export function removeColonFromText(text)
{
	var hyphenRemovedText = text.replace(/:/g, '');
	return hyphenRemovedText;
}

export function countOfOccurrencesInStr(str, value) 
{
	var regExp = new RegExp(value, "gi");
	return (str.match(regExp) || []).length;
}

export function getKeyValues(jsonObject)
{
	var jsonKeys = [];
	for (var k in jsonObject)
	{
		jsonKeys.push(k);
	}
	return jsonKeys;
}

export function findIdxByKey(dataArr, key)
{
	var idx = -1;
	for(var dataCount = 0; dataCount < dataArr.length; dataCount++)
	{
		if(typeof(dataArr[dataCount]) == "object" && key in dataArr[dataCount])
		{
			idx = dataCount;
			break;
		} 
	}
	return idx;
}

export function frequencyToCPM(data)
{
	return (data * 60);
}

export function isURL(string)
{
	try
	{
		new URL(string);
		return true;
	} catch (error)
	{
		return false;
	}
}

export function isS3URLExpired(url)
{
	let isExpiredFlg = false;
	try
	{
		if(isURL(url))
		{
			let imageParams = new URLSearchParams(url);
			let fileGeneratedDate = imageParams.get("X-Amz-Date");	// 20240906T132157Z
			let expires = imageParams.get("X-Amz-Expires");
			let part1 = fileGeneratedDate.slice(0, 4);	// 2024
			let part2 = fileGeneratedDate.slice(4, 6);	// 09
			let part3 = fileGeneratedDate.slice(6, 11);	// 06T13
			let part4 = fileGeneratedDate.slice(11, 13);	// 21
			let part5 = fileGeneratedDate.slice(13);	// 57z
			let fileExpiredDateAndTime = new Date(part1 + "-" + part2 + "-" + part3 + ":" + part4 + ":" + part5);	// 2024-09-06T13:21:57Z
			fileExpiredDateAndTime.setSeconds(fileExpiredDateAndTime.getSeconds() + parseInt(expires));
			isExpiredFlg = new Date() > fileExpiredDateAndTime;
		}
	} catch(error)
	{

	}
	return isExpiredFlg;
}

export function getRestructuredGraphDataAndYAxisLabels(
	graphParamsHavingSameUnitAsSelectedGraphParam,
	multipleParamGraphDataPoints,
	showDatetimeInXAxis = true
) {
	const datetimeParamGraphValuesMap = new Map();
	const selectedGraphParamLength = graphParamsHavingSameUnitAsSelectedGraphParam.length;

	for (let graphParamIdx = 0; graphParamIdx < selectedGraphParamLength; graphParamIdx++)
	{
		const graphParam = graphParamsHavingSameUnitAsSelectedGraphParam[graphParamIdx];
		const graphParamDataPointsObj = multipleParamGraphDataPoints[graphParam];
		if (!graphParamDataPointsObj) continue;

		const graphData = graphParamDataPointsObj.graphData;

		for (let i = 0; i < graphData.length; i++)
		{
			const datetime = graphData[i][0];
			const value = graphData[i][1];

			let paramValues = datetimeParamGraphValuesMap.get(datetime);
			if (!paramValues)
			{
				paramValues = new Array(selectedGraphParamLength);
				for (let k = 0; k < selectedGraphParamLength; k++) paramValues[k] = NaN;
				datetimeParamGraphValuesMap.set(datetime, paramValues);
			}

			paramValues[graphParamIdx] = value;
		}
	}

	const datetimeParamGraphValuesMapEntries = Array.from(datetimeParamGraphValuesMap.entries());
	datetimeParamGraphValuesMapEntries.sort((a, b) => a[0] - b[0]);

	const restructuredGraphData = [];

	for (let i = 0; i < datetimeParamGraphValuesMapEntries.length; i++)
	{
		const datetime = datetimeParamGraphValuesMapEntries[i][0];
		const paramValues = datetimeParamGraphValuesMapEntries[i][1];

		let hasValidYValues = false;
		for (let j = 0; j < selectedGraphParamLength; j++)
		{
			const paramValue = paramValues[j];
			if (!isNaN(paramValue))
			{
				hasValidYValues = true;
				break;
			}
		}

		if (!hasValidYValues) continue;

		if (showDatetimeInXAxis)
		{
			const row = new Array(selectedGraphParamLength + 1);
			row[0] = Number(datetime);
			for (let j = 0; j < selectedGraphParamLength; j++)
			{
				row[j + 1] = paramValues[j];
			}
			restructuredGraphData.push(row);
		} else
		{
			restructuredGraphData.push(paramValues.slice());
		}
	}

	return restructuredGraphData;
}


export function buildGraphData({
	graphParams,
	selectedGraphParam,
	graphParamsUnitsAndPreference,
	multipleParamGraphDataPoints,
	showDatetimeInXAxis = true,
	selectedXAxisParam = null,
})
{
	let selectedGraphParamUnitInfo = graphParamsUnitsAndPreference[selectedGraphParam];
	let selectedGraphParamDefaultUnit = selectedGraphParamUnitInfo?.defaultUnit;
	let graphParamsHavingSameUnitAsSelectedGraphParam = getGraphParamsHavingSameUnitAsSelectedGraphParam(graphParams, graphParamsUnitsAndPreference, selectedGraphParam, selectedXAxisParam, selectedGraphParamDefaultUnit); // excludes selected x axis param
	let { restructuredGraphData, xAxisMinimum, xAxisMaximum, expValue, outlier } = getGraphInfo(graphParamsHavingSameUnitAsSelectedGraphParam, multipleParamGraphDataPoints, showDatetimeInXAxis, selectedXAxisParam);
	let selectedGraphParamUnit = selectedGraphParamUnitInfo?.preference == appConstants.DEFAULT_UNIT_PREFERENCE ? selectedGraphParamUnitInfo.defaultUnit : selectedGraphParamUnitInfo.altUnit1;

	return {
		graphParamsHavingSameUnitAsSelectedGraphParam: graphParamsHavingSameUnitAsSelectedGraphParam,
		graphData: restructuredGraphData,
		xAxisMinimum,
		xAxisMaximum,
		unit: selectedGraphParamUnit,
		expValue,
		outlier
	};
};

function getGraphParamsHavingSameUnitAsSelectedGraphParam(graphParams, graphParamsUnitsAndPreference, selectedGraphParam, selectedXAxisParam, selectedGraphParamDefaultUnit)
{
	let graphParamsHavingSameUnitAsSelectedGraphParam = [];

	if (selectedGraphParam && graphParamsUnitsAndPreference)
		{
			if(selectedXAxisParam === null) // time-series graph
			{
				graphParamsHavingSameUnitAsSelectedGraphParam = graphParams.reduce((graphParamsHavingSameUnitAsSelectedGraphParam, graphParam) =>
				{
					const unitInfo = graphParamsUnitsAndPreference[graphParam];
					if (unitInfo && unitInfo.defaultUnit === selectedGraphParamDefaultUnit)
					{
						return [...graphParamsHavingSameUnitAsSelectedGraphParam, graphParam];
					}
					return graphParamsHavingSameUnitAsSelectedGraphParam;
				}, []);
			} else // params-comparison graph
			{
				graphParamsHavingSameUnitAsSelectedGraphParam = graphParams.reduce((graphParamsHavingSameUnitAsSelectedGraphParam, graphParam) =>
				{
					const unitInfo = graphParamsUnitsAndPreference[graphParam];
					if (unitInfo && unitInfo.defaultUnit === selectedGraphParamDefaultUnit)
					{
						if(graphParam !== selectedXAxisParam) // To exclude selectedXAxisParam from the list of params
						{
							return [...graphParamsHavingSameUnitAsSelectedGraphParam, graphParam];
						}
					}
					return graphParamsHavingSameUnitAsSelectedGraphParam;
				}, []);
			}
		}
	return graphParamsHavingSameUnitAsSelectedGraphParam;
}

function getGraphInfo(graphParamsHavingSameUnitAsSelectedGraphParam, multipleParamGraphDataPoints, showDatetimeInXAxis, selectedXAxisParam)
{
	let xAxisMinimum = Infinity;
	let xAxisMaximum = -Infinity;
	let expValue = {};
	let outlier = {};

	const selectedGraphParamAndRelatedGraphParams = [
		...(selectedXAxisParam ? [selectedXAxisParam] : []),
		...graphParamsHavingSameUnitAsSelectedGraphParam
	];

	let restructuredGraphData = getRestructuredGraphDataAndYAxisLabels(selectedGraphParamAndRelatedGraphParams, multipleParamGraphDataPoints, showDatetimeInXAxis);

	selectedGraphParamAndRelatedGraphParams.forEach((param) =>
	{
		if (multipleParamGraphDataPoints.hasOwnProperty(param))
		{
			const graphMeta = multipleParamGraphDataPoints[param];

			if (typeof graphMeta.xAxisMinimum === 'number' && selectedXAxisParam !== param)
			{
				xAxisMinimum = Math.min(xAxisMinimum, graphMeta.xAxisMinimum);
			}
			if (typeof graphMeta.xAxisMaximum === 'number' && selectedXAxisParam !== param)
			{
				xAxisMaximum = Math.max(xAxisMaximum, graphMeta.xAxisMaximum);
			}
			if (graphMeta.expValue || graphMeta.expValue === 0)
			{
				expValue[param] = graphMeta.expValue;
			}
			if(graphMeta.outlier && graphMeta.outlier.length > 0)
			{
				outlier[param] = graphMeta.outlier;
			}
		}
	});

	if (selectedXAxisParam)
	{
		let min = Infinity;
		let max = -Infinity;
		for(let i = 0; i < restructuredGraphData.length; i++)
		{
			if(restructuredGraphData[i][0] < min)
			{
				min = restructuredGraphData[i][0];
			}
			if(restructuredGraphData[i][0] > max)
			{
				max = restructuredGraphData[i][0];
			}
		}
		const range = max - min || Math.abs(max) || 1;
		const padding = range * 0.05;

		xAxisMaximum = max + padding;
		xAxisMinimum = min - padding;
		restructuredGraphData = restructuredGraphData.sort((a, b) => a[0] - b[0]);
	}
	return {
		restructuredGraphData,
		xAxisMinimum,
		xAxisMaximum,
		expValue,
		outlier
	};
}

export function isAssetStateValid(assetState)
{
	if (assetState === null || assetState === undefined)
	{
		return false;
	}

	const invalidAssetStates = [
		appConstants.ASSET_STATE_DECOMMISSIONED,
		appConstants.ASSET_STATE_SENSOR_DETACH_SUSPECTED,
		appConstants.ASSET_STATE_DATA_RX_TIMEOUT_EXCEEDED
	];
	return !invalidAssetStates.includes(assetState);
}